export default {
    navbar: {
        back: 'Back',
        signout: 'Sign out'
    },
    home: {
        title: "MC's Panel",
        newGameBtn: 'New Game',
        gameListBtn: 'Extract games decisions',
        gameCodeLabel: 'Game Code',
        accessBtn: 'Access'
    },
    newGame: {
        step1: {
            title: 'Game configuration (step 1 of 3)',
            subtitle: 'Basic configuration',
            section: {
                players: 'Players',
                seasonsAndRaces: 'Seasons & Races',
                phase: 'Phase information'
            },
            numHumans: 'Number of human players',
            numPlayers: 'Total number of players',
            seasons: 'Number of seasons',
            races: 'Number of races per season',
            budgetPerSeason: 'Base budget per season',
            timePerPhase: 'Time per phase (mins)',
            nextBtn: 'NEXT'
        },
        step2: {
            title: 'Game configuration (step 2 of 3)',
            section: {
                engine: 'Engine Catalog',
                gearbox: 'Gearbox Catalog',
                wheels: 'Wheels Catalog',
                discounts: 'Discounts',
                maintenance: 'Item Maintenance: health recovery'
            },
            option: 'Option {{number}}',
            optionWheelsFIA: {
                title: 'FIA Wheels',
                text: 'Basic wheels provided by FIA when budget is not enough to acquire wheels from supplier.'
            },
            name: 'Name',
            shortname: 'Short name',
            description: 'Description',
            performanceMax: 'Performance Max (index)',
            expectedAssetLife: 'Expected Asset Life (km)',
            price: 'Price ($m)',
            discountTwo: 'For 2 units (%)',
            discountThree: 'For 3 or more units (%)',
            healthRecoveryLabel: 'Label',
            healthRecoveryValue: 'Value (%)',
            nextBtn: 'NEXT'
        },
        step3: {
            title: 'Game configuration (step 3 of 3)',
            bot: 'Bot {{bot}}',
            maxBudget: 'Max Budget ($m)',
            maxTime: 'Max Time (mins)',
            maxTimeHelper: {
                default: 'Recommended: {{value}}',
                min: 'Acceptable minimum: {{value}}',
                max: 'Acceptable maximum: {{value}}'
            },
            nextBtn: 'GENERATE'
        }
    },
    gameDetail: {
        title: 'Game detail',
        players: 'Players',
        gameCode: 'Game Code',
        totalPlayers: 'Total of players:',
        game: 'Game specifications',
        copyToClipboard: 'Copy to clipboard'
    },
    game: {
        nav: {
            playerDecisions: 'Player decisions',
            resultsComparision: 'Results comparision'
        },
        season: 'Season {{count}}'
    },
    gameList: {
        filters: {
            title: 'Select filters:',
            startDate: 'Start date',
            endDate: 'End date',
            searchCode: 'Search code',
            onlyCompleted: 'Show only completed'
        },
        emptyList: 'Empty list...',
        emptyFilteredList: 'There is no result for these filters...',
        tableHeaders: {
            code: 'CODE',
            players: 'PLAYERS',
            bots: 'BOTS',
            seasons: 'SEASONS',
            races: 'RACES',
            status: 'STATUS'
        },
        status: {
            completed: 'Completed',
            incompleted: 'Incompleted',
        },
        downloadBtn: 'Download'
    }
}



// WEBPACK FOOTER //
// src/lang/locales/en/mc.js